import { TourType } from '@/_models/Tour';
import { GameBook } from '../../../../_models/game/GameBook';

export interface Props {
  tourType: TourType;
  show: boolean;
  onClose: () => void;
  book: GameBook;
  unlockedChapterIds: number[];
  tryButtonPlaySound: () => void;
  moveToSweep: (sweepUuid: string, rotation?: { x: number; y: number }) => void;
}

export enum GameBookLocationType {
  sweep = 'sweep',
  tourLink = 'tourLink',
}

export type PageData = {
  locationTourLink?: string;
  locationType: GameBookLocationType;
  id: number;
  title: string;
  description: string;
  url?: string;
  moveToSweepUuid: string;
};
